export default "__VITE_ASSET__DfCJEu$Q__"